import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './navbar.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import { CopilotProvider } from './contexts/CopilotContext';
import { CommonTasksProvider } from './contexts/CommonTasksContext';
import { CustomTemplatesProvider } from './contexts/CustomTemplatesContext';
import { TranslationProvider } from './contexts/TranslationContext';
import { AuthProvider } from './contexts/AuthContext';
import { StatusProvider } from './contexts/StatusContext';

import { AIQuizProvider } from './contexts/AIQuizContext';
import { AITestProvider } from './contexts/AITestContext';
import { ClientProvider } from './contexts/ClientContext';
import { ContactusProvider } from './contexts/ContactusContext';
import { AssistantProvider } from './contexts/AssistantContext';
import { CompareAIProvider } from './contexts/CompareAIContext';
import { ComprehensiveResponsesProvider } from './contexts/ComprehensiveResponsesContext';
import { BetterResponsesProvider } from './contexts/BetterResponsesContext';
import { GlobalSearchProvider } from './contexts/GlobalSearchContext';
import { DocumentAnalysisProvider } from './contexts/DocumentAnalysisContext';
import { JobInterviewProvider } from './contexts/JobInterviewContext';
import { StocksProvider } from './contexts/StocksContext';
import { MarketingProvider } from './contexts/MarketingContext';

import 'katex/dist/katex.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   
   
    <AuthProvider>
    <StatusProvider>
      <ClientProvider>
        
        <CopilotProvider>
          <AssistantProvider>
            <DocumentAnalysisProvider>
            <CommonTasksProvider>
           <BetterResponsesProvider>
            <CompareAIProvider> 
          <ComprehensiveResponsesProvider> 
            <CustomTemplatesProvider>
              <StocksProvider>
                <MarketingProvider>
             <TranslationProvider>
             
              <AIQuizProvider>
                <AITestProvider>
                <ContactusProvider>
                <GlobalSearchProvider>
                  <JobInterviewProvider>
                  <App /> 
                  </JobInterviewProvider>
                  </GlobalSearchProvider>
                </ContactusProvider>
                </AITestProvider>
                </AIQuizProvider>
              
             </TranslationProvider>
             </MarketingProvider>
             </StocksProvider>
             </CustomTemplatesProvider>
            </ComprehensiveResponsesProvider> 
            </CompareAIProvider>  
            </BetterResponsesProvider> 
          </CommonTasksProvider>
          </DocumentAnalysisProvider>
          </AssistantProvider>
        </CopilotProvider>
    </ClientProvider>
    </StatusProvider>
    </AuthProvider>
    
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
